<lib-panel-layout>
  <div
    class="flex w-full min-w-0 flex-col gap-3 whitespace-normal text-left text-sm leading-relaxed text-white"
    [attr.aria-busy]="loading()">
    <p class="text-editor-muted">{{ 'EDITOR.OBJECT_DETECTION.DESCRIPTION' | translate }}</p>

    @if (loading()) {
      <div class="flex items-center gap-2" role="status">
        <lib-spinner size="sm" variant="primary" />
        <span>{{ 'EDITOR.OBJECT_DETECTION.DETECTING' | translate }}</span>
      </div>
    } @else if (errorKey(); as error) {
      <p class="text-red-300" role="alert">{{ error | translate }}</p>
    } @else if (objects(); as detectedObjects) {
      <p role="status">
        {{
          (detectedObjects.length ? 'EDITOR.OBJECT_DETECTION.COUNT' : 'EDITOR.OBJECT_DETECTION.EMPTY')
            | translate: { count: detectedObjects.length }
        }}
      </p>
      @if (detectedObjects.length) {
        <ol class="list-decimal space-y-2 pl-5">
          @for (object of detectedObjects; track $index) {
            <li class="break-words">{{ object.label }}</li>
          }
        </ol>
      }
      <p class="text-xs text-editor-muted">{{ 'EDITOR.OBJECT_DETECTION.OVERLAY_NOTE' | translate }}</p>
    } @else if (!ready()) {
      <p role="status" class="text-editor-muted">{{ 'EDITOR.OBJECT_DETECTION.WAIT_FOR_IMAGE' | translate }}</p>
    }
  </div>

  <div panelActions class="flex flex-col gap-2">
    @if (downloadUrl(); as url) {
      <a libButton variant="outline" size="xs" class="text-white!" [href]="url" download="object-detection.json">
        {{ 'EDITOR.OBJECT_DETECTION.DOWNLOAD_JSON' | translate }}
      </a>
    }
    @if (loading()) {
      <button libButton variant="outline" class="text-white!" type="button" (click)="cancelRequested.emit()">
        {{ 'EDITOR.OBJECT_DETECTION.CANCEL' | translate }}
      </button>
    } @else {
      <button libButton type="button" [disabled]="!ready()" (click)="detectRequested.emit()">
        {{ 'EDITOR.OBJECT_DETECTION.DETECT' | translate }}
      </button>
    }
  </div>
</lib-panel-layout>
